<template>
  <!-- 店铺信息-添加案例 -->
  <div class="Case-box">
    <!-- 案例编辑 标题 -->
    <div class="top-title">
      <p class="title">身份认证</p>
    </div>
    <div class="verify">
      <!-- 法人姓名 身份证号 -->
      <div class="LegalPerson">
        <p class="title-p">法人姓名：</p>
        <p class="LegalPerson-name">张三</p>
        <p class="title-p">身份证号：</p>
        <p class="LegalPerson-name">411303199804101514</p>
      </div>
      <!-- 验证方式 -->
      <div class="LegalPerson">
        <p class="title-p"><span style="color: red">*</span>验证方式：</p>
        <!-- 选择验证方式 -->
        <div class="select-verify" v-for="(item, index) in wayArr" :key="index">
          <div :class="item.id == waySelect ? 'Options' : 'notOptions'"></div>
          <p class="way-p">{{ item.way }}</p>
          <p>{{ item.data }}</p>
        </div>
      </div>
      <!-- 验证码 -->
      <div class="LegalPerson">
        <p class="title-p"><span style="color: red">*</span>验证码：</p>
        <div class="code-box">
          <el-input class="firm-clickable" v-model="ruleForm.Code" placeholder="请输入"></el-input>
          <!-- @click="second == 60 ? handelInvoke('ruleForm') : ''" -->
          <p class="clickCode">
            {{
              second === totalSecond && sendNum == 0
                ? "获取验证码"
                : second === totalSecond && sendNum != 0
                ? "再次获取验证码"
                : second + `秒后重新发送`
            }}
          </p>
        </div>
      </div>
      <!-- 上传营业执照 -->
      <div class="LegalPerson">
        <p class="title-p"><span style="color: red">*</span>上传营业执照：</p>
        <div class="Upload-box">
          <img :src="imgSrc" alt="" v-if="imgSrc != ''" />
          <input
            type="file"
             ref="clearFile"
            @change="onFileChange"
            id="file"
            v-if="imgSrc == ''"
          />
          <input
            type="button"
            value="点击上传营业执照"
            class="btn firm-clickable"
            @click="clickFile()"
            v-if="imgSrc == ''"
          />
          <p v-if="imgSrc == ''">请上传.jpg .png文件，大小不得超过10M</p>
        </div>
      </div>
      <!-- 点击勾选已阅读 -->
      <div class="LegalPerson">
        <div class="select-verify">
          <div
            :class="read ? 'Options' : 'notOptions'"
            @click="read = !read"
          ></div>
          <p class="way-p">
            已阅读并同意xxx<span style="color: #409eff "
              >《店铺协议》《隐私政策》《免责声明》《合作协议》</span
            >，允许xxx统一管理本人账号信息
          </p>
        </div>
      </div>
    </div>
    <!-- 上一步 确认 -->
    <div class="button">
      <p class="firm-clickable" @click="handelVerifyReturn">返回上一步</p>
      <p class="firm-clickable" @click="handelVerifyOk">确认</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        Code: "",
      },
      read: false, // 阅读协议
      wayArr: [
        {
          way: "手机验证",
          data: "18237742511",
          id: "1",
        },
        {
          way: "邮箱验证",
          data: "18237742511@163.com",
          id: "2",
        },
      ], //选择验证方式
      waySelect: "1",
      imgSrc: "",
      TXurl: "", //营业执照上传到腾讯云的地址
      totalSecond: 60, // 总秒数
      second: 60, // 倒计时的秒数
      timer: null, // 定时器 id
      sendNum: "0", // 发送次数首次叫获取验证码之后叫再次发送验证码
    };
  },
  watch: {},
  components: {},
  created() {},
  destroyed() {
    clearInterval(this.timer);
    this.timer = null; // 重置定时器 id
    this.second = this.totalSecond; // 归位
  },
  methods: {
    // 返回上一步
    handelVerifyReturn(){this.$emit("handelVerifyReturn");},
    // 确认
    handelVerifyOk(){this.$emit("handelVerifyOk");},
    // 点击上传身份证
    clickFile(num) {
      // 上传正面
      const input = document.querySelector("#file");
      input.click();
    },
    // 调用上传文件/图片封装的js
    async onFileChange(event, opt) {
      var file = event.target.files[0] || event.dataTransfer.files[0];
      if (!file) return;
      let URL = window.URL || window.webkitURL;
      var arr = await this.$tool.onFileChangeNew(event, opt);
      if (arr && arr.code == 0) {
        this.imgSrc = URL.createObjectURL(file);
        this.TXurl = arr.TXurl;
      }
      if (this.$refs.clearFile) this.$refs.clearFile.value = "";
    },
    // 返回
    handelBack() {
      this.$emit("handelBack");
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-input__inner {
  height: 35px !important;
  border: 1px solid #409eff ;
}
// 文本输入框样式
/deep/.el-textarea {
  height: 100px !important;
}
/deep/.el-textarea__inner {
  height: 90px !important;
  border: 1px solid #409eff ;
}

// 外层div
.Case-box {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  .top-title {
    width: 100%;
    height: 40px;
    display: flex;
    position: relative;
    .title {
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: #409eff ;
      border-radius: 10px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      margin: auto;
    }
  }
  .verify {
    width: 100%;
    min-height: 35px;
    margin-top: 50px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
   color: #409eff ;
    font-weight: 400;
    line-height: 35px;
    .LegalPerson {
      width: 100%;
      display: flex;
      margin-bottom: 30px;
      .title-p {
        min-width: 110px;
        height: 35px;
        line-height: 35px;
        text-align: right;
      }
      .LegalPerson-name {
        width: 130px;
      }
      .select-verify {
        min-width: 260px;
        display: flex;
        font-size: 16px;
        color: #333333;
        .notOptions {
          width: 18px;
          height: 18px;
          border: 1px solid gray;
          margin: auto 0;
          border-radius: 50%;
        }
        .Options {
          width: 18px;
          height: 18px;
          border: 1px solid gray;
          margin: auto 0;
          border-radius: 50%;
          background-image: url("../../../../../assets/imgs/gouxuan@3x.svg");
          background-size: 100% 100%;
                  cursor: pointer;
}
        .way-p {
          margin-left: 10px;
          margin-right: 20px;
        }
      }
      // 验证码 框
      .code-box {
        width: 370px;
        height: 35px;
        line-height: 35px;
        position: relative;
        .clickCode {
          position: absolute;
          top: 2px;
          right: 20px;
          color: rgba(97, 144, 232, 0.5);
          cursor: pointer;
        }
      }
      // 上传营业执照
      .Upload-box {
        width: 370px;
        height: 200px;
        border: 1px dashed #409eff ;
        margin-right: 20px;
        img {
          width: 100%;
          height: 100%;
        }
        #file {
          display: none;
        }
        #file1 {
          display: none;
        }
        input {
          border: none;
          box-shadow: none;
          outline: none;
          background-color: transparent;
          width: 100%;
          text-align: center;
          color: #409eff ;
          margin-top: 60px;
        }
        p {
          width: 100%;
          text-align: center;
          font-size: 10px;
        }
      }
    }
  }
  .button {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: flex-end;
    margin-top: 80px;
    p {
      cursor: pointer;
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #ffffff;
      border: 1px solid #999999;
      border-radius: 5px;
      font-size: 16px;
      color: #333333;
      margin-left: 20px;
    }
    p:nth-child(2) {
      background: #409eff ;
      color: #ffffff;
    }
  }
}
</style>
